import AuthLayout from './AuthLayout'

// Eagerly available for logout and public-route transitions, including sessions
// opened on a protected deep link that have never downloaded the login route.
export default function AuthSkeleton() {
    return <AuthLayout>
        <div data-route-loading="true" data-route-skeleton="auth" role="status" aria-label="Loading sign-in page" aria-busy="true">
            <div aria-hidden="true" className="animate-pulse motion-reduce:animate-none">
                <div className="h-8 w-2/3 rounded bg-white/20" />
                <div className="h-4 w-full rounded bg-white/10 mt-3 mb-8" />
                {[0, 1].map(index => <div key={index} className="my-5">
                    <div className="h-5 w-24 rounded bg-white/20 mb-4" />
                    <div className="h-8 w-full border-b border-deselectPurple" />
                </div>)}
                <div className="h-[50px] w-full rounded-full bg-highlightColor/40 mt-8 mb-6" />
                <div className="h-[46px] w-full rounded-full border border-deselectPurple mb-4" />
                <div className="h-4 w-1/2 rounded bg-white/10 mx-auto mb-5" />
            </div>
        </div>
    </AuthLayout>
}
